/* RESPONSIBLE TEAM: team-email */
import Model, { attr } from '@ember-data/model';

export default class Settings extends Model {
  @attr('boolean') declare showFinFooter: boolean;
  @attr('boolean') declare dmarcStrict: boolean;
}
